import { Button, Tab, TabList, TabPanel, TabPanels, Tabs, useDisclosure } from '@chakra-ui/react'

import { Icon } from '../../../components/Icon'
import { PageTitle } from '../../../components/PageTitle'
import { useHasRole } from '../../../helpers'
import BulkEditPricesModal from './BulkEditPricesModal'
import CoursesListPage from './Courses/CoursesPage'
import CoursesCategoryPage from './CoursesCategory/CoursesCategoryPage'
import CoursesDynamicsPage from './CoursesDynamics/CoursesDynamicsPage'
import CoursesObjectivesPage from './CoursesObjectives/CoursesObjectivesPage'
import CoursesOnlinePage from './CoursesOnline/CoursesOnlinePage'
import KnowledgeAreaPage from './KnowledgeArea/KnowledgeAreaPage'
import PromoBannersPage from './PromoBanners/PromoBannersPage'

const CoursesPage = () => {
  const hasRole = useHasRole()
  const canViewPromoBanners = hasRole('view_promo_banners')
  const canEditCourse = hasRole('edit_course')
  const { isOpen: isBulkOpen, onOpen: onBulkOpen, onClose: onBulkClose } = useDisclosure()

  return (
    <>
      <PageTitle
        title="Gerenciamento de Cursos"
        description="Cursos, categorias e áreas de conhecimento publicados no site"
        actions={
          canEditCourse && (
            <Button size="sm" colorScheme="magenta" variant="outline" onClick={onBulkOpen} fontWeight="normal">
              <Icon name="lni lni-tag" mr="6px" />
              Editar Preços em Lote
            </Button>
          )
        }
      />
      <Tabs isLazy>
        <TabList>
          <Tab>Cursos presenciais/ao vivo</Tab>
          <Tab>Cursos online/vídeo-aula</Tab>
          <Tab>Áreas de Conhecimento</Tab>
          <Tab>Categorias de Cursos</Tab>
          <Tab>Dinâmica de Ensino</Tab>
          <Tab>Objetivo do Curso</Tab>
          {canViewPromoBanners && <Tab>Banners de Cursos</Tab>}
        </TabList>

        <TabPanels>
          <TabPanel>
            <CoursesListPage />
          </TabPanel>
          <TabPanel>
            <CoursesOnlinePage />
          </TabPanel>
          <TabPanel>
            <KnowledgeAreaPage />
          </TabPanel>
          <TabPanel>
            <CoursesCategoryPage />
          </TabPanel>
          <TabPanel>
            <CoursesDynamicsPage />
          </TabPanel>
          <TabPanel>
            <CoursesObjectivesPage />
          </TabPanel>
          {canViewPromoBanners && (
            <TabPanel>
              <PromoBannersPage />
            </TabPanel>
          )}
        </TabPanels>
      </Tabs>

      <BulkEditPricesModal isOpen={isBulkOpen} onClose={onBulkClose} />
    </>
  )
}

export default CoursesPage
